module.exports = __webpack_public_path__ + "img/fi-rr-file-music.06104bca.svg";